export default "__VITE_ASSET__1cYSDkC6__"